let host=process.env.VUE_APP_MYHOST
export const config = {
  apiUrl: host+'api/',
  authUrl: 'https://oauth.mifors.com/authserver/oauth/token',  
  registerUrl: host+'api/cabinet/register',
  confirmUrl: host+'api/cabinet/confirm',
  passRestore: host+'api/cabinet/restore',
  client: {
    id: 'fooClientIdPassword',
    secret: 'secret'
  }
}